module.exports = __webpack_public_path__ + "img/product_easytag1.9ba80c86.jpg";